module.exports = __webpack_public_path__ + "static/img/post_02-300x184.613b613.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/post_02-300x184.jpg
// module id = NdJc
// module chunks = 0